import { useAppSelector } from "../../../../../redux/hooks"
import { KTIcon } from "../../../../../_metronic/helpers"
import { useEffect, useState } from 'react'
import { getCTXStatus, getCTXStatusGlobal } from "../requests/request"
import { useAuth } from "../../../auth"

export default function StatusCtx(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const { currentUser } = useAuth()
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const [statusCTX, setstatusCTX] = useState([{
    name: '',
    status: '',
    subscription: ''
  }])

  useEffect(() => {
    const fetchData = async () => {
      try {
        //if (FlagReg === true) {
          if (currentUser?.ListPermiso?.includes('Home.Status') && Type !== 'CloudGlobal' && props.id === 1 && tenant === 0) {
            const response = await getCTXStatus(Id, Type, nameregion);
            if (response.data && response.data.error === 'id suscription invalido') {
              setstatusCTX([])
            } else {
              setstatusCTX(response.data);
            }
            // Puedes agregar lógica adicional aquí si es necesario
          }

          else if (currentUser?.ListPermiso?.includes('Home.Status') && Type !== 'CloudGlobal' && props.id === 1 && tenant !== 0) {
            const response = await getCTXStatusGlobal(Id, tenant, Type, nameregion);
            if (response.data && response.data.error === 'id suscription invalido') {
              setstatusCTX([])
            } else {
              setstatusCTX(response.data);
            }
            // Puedes agregar lógica adicional aquí si es necesario
          }
          else if (Id && Type === 'CloudGlobal' && tenant === 0 /*&&currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.Status')*/) {
            getCTXStatus(Id).then(response => {
              if (response.data && response.data.error === 'suscriptionId error') {
                setstatusCTX([])
              } else {
                setstatusCTX(response.data);
              }
            })
          }

          else if (Id && Type === 'CloudGlobal' && tenant !== 0 && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
            getCTXStatusGlobal(Id, tenant).then(response => {
              if (response.data && response.data.error === 'suscriptionId error') {
                setstatusCTX([])
              } else {
                setstatusCTX(response.data);
              }
            })
          }
        //}
      } catch (error: any) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [FlagReg, nameregion, props.id]);

  useEffect(() => {
    if (Id && Type !== '' || Type !== null) {
      if (currentUser?.ListPermiso?.includes('Home.Status') && Id === -1 && props.id === 1 && tenant === 0) {
        getCTXStatus(-1).then(response => {
          if (response.data && response.data.error === 'id suscription invalido') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data);
          }
        });
      }
      else if (currentUser?.ListPermiso?.includes('Home.Status') && Id === -1 && props.id === 1 && tenant !== 0) {
        getCTXStatusGlobal(-1, tenant).then(response => {
          if (response.data && response.data.error === 'id suscription invalido') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data);
          }
        });
      }
    }
  }, [Id, Type])

  return (
    <>
      <div className="card card-custom border border-gray-300 ">
        <div>
          <br />
          <div className='text-marino f-titulo fs-md text-center'>INSTANCES STATUS</div>
        </div>
        <div className="border shadow-sm rounded-lg menu-scroll">
          <div className="relative w-full overflow-auto">
            <div className="card-body card-scroll table-container h-250px">
              {statusCTX.length === 0 ? (
                <div className="no-data-message">No Data Available</div>
              ) : (
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead className='table-header-light bg-marino table-header-fixed'>
                    <tr>
                      <th className="table-cell">CTX Instance</th>
                      {Type === 'CloudGlobal' && <th className="table-cell">Subscription</th>}
                      <th className="table-cell">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusCTX?.map((d, i) => (
                      <tr key={i} className="table-row">
                        {Id !== 0 && d.name.includes(Type) && <td className="table-cell">{d.name}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.name}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d.subscription}</td>}
                        {Id !== 0 && d.status === "UP" && d.name.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === "UP" && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {Id !== 0 && d.status === "DOWN" && d.name.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === "DOWN" && <td className="table-cell"><KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' /></td>}
                        {Id !== 0 && d.status === "UNKNOWN" && d.name.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {Type === 'CloudGlobal' && d.status === "UNKNOWN" && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {Id === 0 && Type !== 'Global' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <tr>
                      <td className="text-center">Select a Cloud with available subscriptions</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer"></div>
          </div>
        </div>
      </div>
    </>
  )
}
